import { isArray } from 'lodash';
export const integer = (value) => {
    return !isArray(value) && String(parseInt(value, 10)) === String(value);
};
